// Do not optimize this import because it causes circular injection
import { EIIState } from 'app/shared/enums/international-invoice.enums';

export const INVOICE_STATE_MAP: Record<EIIState, { status: string, statusComment: string }> = {
  [EIIState.IEW]: { status: 'Відправлено', statusComment: 'Переглядайте деталі міжнародного відправлення в розділі «Мої посилки»' },
  [EIIState.CLOSED]: { status: 'Отримано', statusComment: 'Переглядайте деталі міжнародного відправлення в розділі «Мої посилки»' },
  [EIIState.REQUEST]: { status: 'Заявка', statusComment: 'Очікує на верифікацію' },
  [EIIState.UPDATED]: { status: 'Оновлена', statusComment: 'Очікує на верифікацію' },
  [EIIState.VERIFIED]: { status: 'Верифіковано', statusComment: 'Готово до відправки' },
  [EIIState.NOT_VERIFIED]: { status: 'Не верифіковано', statusComment: '' },
}

export const DEFAULT_SUBSTATE = 'Інше';

export const CONTACT_COMMENT = `Потребує уточнення. Зв'яжіться з нами за телефоном 0443500544, 0678300544`;


export const ZEBRA_ALLOWED_PRINT_STATES: EIIState[] = [
  EIIState.VERIFIED,
];

export enum EPaymentInfoSource {
  API = 'API',
  CACHE = 'CACHE',
}
